import { useState, useEffect } from 'react';
import { Switch, Text, Flex } from '@mantine/core';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import {db} from "../../firebase";



function Setting() {
    const [enableRushOrder, setEnableRushOrder] = useState<boolean | null>(null);
    const [enableUps2DayShipping, setEnableUps2DayShipping] = useState<boolean | null>(null);
    const [savingSettings, setSavingSettings] = useState<Record<string, boolean>>({});

    useEffect(() => {
        const fetchSetting = async (
            settingId: string,
            setState: (enabled: boolean) => void
        ) => {
            const settingDoc = await getDoc(doc(db, 'settings', settingId));
            if (settingDoc.exists()) {
                setState(settingDoc.data().enabled);
            } else {
                // If the document doesn't exist, create it with the default value (true)
                await setDoc(doc(db, 'settings', settingId), {
                    enabled: true
                });
                setState(true);
            }
        };
        fetchSetting('rushOrder', setEnableRushOrder);
        fetchSetting('ups2DayShipping', setEnableUps2DayShipping);
    }, []);

    const handleToggle = async (
        settingId: string,
        checked: boolean,
        setState: (enabled: boolean) => void
    ) => {
        const previousValue = settingId === 'rushOrder' ? enableRushOrder : enableUps2DayShipping;
        setState(checked);
        setSavingSettings((prev) => ({ ...prev, [settingId]: true }));
        try {
            // Update the setting in Firebase
            await setDoc(doc(db, 'settings', settingId), {
                enabled: checked
            }, { merge: true });
        } catch (error) {
            console.error(`Failed to update ${settingId} setting`, error);
            setState(previousValue ?? true);
        } finally {
            setSavingSettings((prev) => ({ ...prev, [settingId]: false }));
        }
    };

    return (
        <div>
            <Flex justify="space-between" align="center">
                <Text style={{paddingRight:10}}>Enable Rush Order</Text>
                <Switch
                    checked={enableRushOrder ?? false}
                    disabled={enableRushOrder === null || savingSettings.rushOrder}
                    onChange={(event) =>
                        handleToggle('rushOrder', event.currentTarget.checked, setEnableRushOrder)
                    }
                />
            </Flex>
            <Flex justify="space-between" align="center" mt={12}>
                <Text style={{paddingRight:10}}>Enable 2nd Day Air Shipping</Text>
                <Switch
                    checked={enableUps2DayShipping ?? false}
                    disabled={enableUps2DayShipping === null || savingSettings.ups2DayShipping}
                    onChange={(event) =>
                        handleToggle('ups2DayShipping', event.currentTarget.checked, setEnableUps2DayShipping)
                    }
                />
            </Flex>
        </div>
    );
}

export default Setting;
